export default "__VITE_ASSET__DG9$OKF___"